// src/utils/exportApi.ts
// エクスポート機能API（rl-api-15-export, api.readlinker.com/export）
//
// 大規模蔵書ユーザーでAPI Gateway(30秒固定タイムアウト)に引っかかったため、
// 同期処理をやめ非同期化。このAPIは即座に「受け付けた」旨を返すのみで、
// 実際のCSV生成・メール送信はバックグラウンドワーカー(rl-api-15-export-worker)が行う。

import axios from 'axios';
import { NEW_API } from '../config/api';

function authHeaders(idToken: string) {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
  };
}

export interface ExportRequestResult {
  status: string;
  email: string;
}

/** POST /export operation_type=request_export */
export async function requestExport(idToken: string): Promise<ExportRequestResult> {
  const res = await axios.post(
    NEW_API.EXPORT,
    { operation_type: 'request_export' },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data as ExportRequestResult;
}
